module.exports = __webpack_public_path__ + "static/img/part_2_green.ab05199a.png";